import { getChildCategories, getParentCategories } from '@/api/category'
import { CategoryState, RootState } from '@/types/store'
import { ActionContext, ActionTree } from 'vuex'

type Context = ActionContext<CategoryState, RootState>

export interface CategoryActions extends ActionTree<CategoryState, RootState> {
  getParentCategories: (ctx: Context) => Promise<void>
  getChildCategories: (
    ctx: Context,
    parents: number[] | undefined,
  ) => Promise<void>
}

export const actions: ActionTree<CategoryState, RootState> = {
  async getParentCategories({ commit }): Promise<void> {
    commit('setIsLoading', true)
    const parents = await getParentCategories()
    commit('setIsLoading', false)
    commit('parentsLoaded', parents)
  },
  async getChildCategories(
    { commit },
    parents: number[] | undefined,
  ): Promise<void> {
    commit('setIsLoading', true)
    const children = await getChildCategories(parents)
    commit('setIsLoading', false)
    commit('childrenLoaded', children)
  },
  resetChildCategories({ commit }): void {
    commit('childrenLoaded', [])
  },
}
